import { isBottlerAdminEnabled } from "../utils/featureFlags";
import { SOP_KO_BOTTLER_ADMIN_ROLE } from "../utils/userAccess";

const breadcrumbsData = [
  {
    title: 'Home',
    path: '/',
  },
  {
    title: 'User Access Management',
    children: [
      { title: 'New Request', path: '/user-roles/new-request' },
      { title: 'Request Status', path: '/user-roles/track-access-request' },
      { title: 'Report', path: '/user-roles/reports' },
      { title: 'Approval Delegation', path: '/user-roles/approval-rights' },
      { title: 'Ticket Summary', path: '/user-roles/ticket-summary' },
      { title: 'Access Control', path: '/user-roles/access-control'},
      ...(isBottlerAdminEnabled ? [
        { title: 'Bottler Onboarding', path: '/bottler-admin/elm-access', requiredRole: SOP_KO_BOTTLER_ADMIN_ROLE },
        { title: 'Domain Whitelist', path: '/bottler-admin/domain-whitelist', requiredRole: SOP_KO_BOTTLER_ADMIN_ROLE },
      ] : []),
    ],
  },
  {
    title: 'New Request',
    path: '/user-roles/new-request',
    children: [],
  },
  {
    title: 'Request Status',
    path: '/user-roles/track-access-request',
    children: [],
  },
  {
    title: 'Report',
    path: '/user-roles/reports',
    children: [],
  },
  {
    title: 'Approval Delegation',
    path: '/user-roles/approval-rights',
    children: [],
  },
  {
    title: 'Ticket Summary',
    path: '/user-roles/ticket-summary',
    children: [],
  },
  {
    title: 'Access Control',
    path: '/user-roles/access-control',
    children: [],
  },
  ...(isBottlerAdminEnabled ? [
    {
      title: 'Bottler Onboarding',
      path: '/bottler-admin/elm-access',
      children: [],
    },
    {
      title: 'Domain Whitelist',
      path: '/bottler-admin/domain-whitelist',
      children: [],
    },
  ] : []),
]

export default breadcrumbsData;
